import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
import swal from "sweetalert2";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../helpers/forms_helper";
import moment from "moment";
import { formatUnitsForReport } from "../../../helpers/units";
import printDiv from "../../../helpers/print_data";
import preloader from "../../../helpers/preloader";
import { AvField, AvForm } from "availity-reactstrap-validation";

const CentralStoreAllItemReturn = (props) => {
  const { SearchBar } = Search;
  useEffect(() => {
    loadAllReturns();
  }, []);

  const [allReturns, setAllReturns] = useState([]);
  const [allReturnsFiltered, setAllReturnsFiltered] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [dateFrom, setDateFrom] = useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const loadAllReturns = async () => {
    const days_diff = moment(dateTo).diff(dateFrom, "days");
    if (days_diff > 31) {
      setAllReturns([]);
      showNotification("Total number of days cannot be more than 31.", "Error");
      return false;
    }
    // console.log(days_diff);
    preloader(true);
    let date_from = moment(dateFrom).format("YYYY-MM-DD"),
      date_to = moment(dateTo).format("YYYY-MM-DD");
    let url = process.env.REACT_APP_BASEURL + "itemreturns/getall";
    const response = await postSubmitForm(url, { date_from, date_to });
    if (response && response.status === 1) {
      preloader(false);
      let sortedData = response.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      );
      setAllReturns(sortedData);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };
  useEffect(() => {
    if (selectedStatus) {
      if (selectedStatus === "All") {
        setAllReturnsFiltered(allReturns);
      } else {
        var data = JSON.parse(JSON.stringify(allReturns));
        setAllReturnsFiltered(
          data.filter((transfer) => transfer.status === selectedStatus),
        );
      }
    }
  }, [allReturns, selectedStatus]);
  function showNotification(message, type) {
    if (type === "Success") swal.fire(type, message, "success");
    else swal.fire(type, message, "error");
  }

  const [detailsModal, setDetailsModal] = useState();
  const [selectedTransfer, setSelectedTransfer] = useState();
  const [selectedTransfer_Items, setSelectedTransfer_Items] = useState([]);
  const [confirmReceive, setConfirmReceive] = useState(false);
  const [confirmRelease, setConfirmRelease] = useState(false);
  function editFormatter(cell, row) {
    if (row.status === "Placed" && row.return_to?.supplier === null) {
      return (
        <button
          class="btn btn-info btn-sm mr-2"
          onClick={() => {
            setConfirmReceive(true);
            setSelectedTransfer(row);
          }}
        >
          {props.t("Receive")}
        </button>
      );
    } else {
      return <span>No Action Required</span>;
    }
  }

  function getReturnToName(cell, row) {
    if (row.return_to?.supplier === null) {
      return row.return_to?.central_store?.name || "";
    } else {
      return row.return_to?.supplier?.name || "";
    }
  }

  const columns = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
      csvExport: false,
    },
    {
      dataField: "return_id",
      text: props.t("Return ID"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      text: props.t("Return From"),
      dataField: "name",
      formatter: (cell, row) => {
        return row.branch_details.name;
      },
      csvFormatter: (cell, row) => {
        return row.branch_details.name;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Return To"),
      dataField: "name",
      formatter: getReturnToName,
      csvFormatter: getReturnToName,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "createdAt",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return moment(row.createdAt).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "status",
      text: props.t("Status"),
      formatter: (cell, row) => {
        if (row.status === "Closed") {
          return (
            <span className="font-size-12 badge-soft-success badge badge-success badge-pill mr-1 mb-1">
              {row.status}
            </span>
          );
        } else {
          return (
            <span className="font-size-12 badge-soft-danger badge badge-success badge-pill mr-1 mb-1">
              {row.status}
            </span>
          );
        }
      },
      csvFormatter: (cell, row) => cell,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      text: props.t("Details"),
      formatter: (cell, row) => {
        return (
          <>
            <span className="text-info">
              <i
                className="mdi mdi-text-box-search font-size-15 mr-2"
                title="View Details"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setDetailsModal(!detailsModal);
                  setSelectedTransfer_Items(row.items);
                }}
              ></i>
            </span>
            <span className="mr-2 text-info">
              <a
                href={"/return_order?return_id=" + row._id}
                target="_blank"
                className="font-size-11"
              >
                <i
                  className="mdi mdi-printer font-size-15"
                  title="Print Return Order"
                  style={{ cursor: "pointer" }}
                ></i>
              </a>
            </span>
          </>
        );
      },
      csvExport: false,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      text: props.t("Action"),
      formatter: editFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      csvExport: false,
    },
  ];

  const columns_items = [
    {
      dataField: "_id",
      hidden: true,
    },
    // {
    //   dataField: "_id",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
    //   text: props.t("#"),
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "3%" };
    //   },
    // },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Ret. Supp. ?"),
      dataField: "return_to_supplier",
      formatter: (cell, row, rowIndex) => {
        return row.return_to_supplier ? "Yes" : "No";
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return row.quantity?.length > 0
          ? formatUnitsForReport(row.quantity)
          : null;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    {
      text: props.t("Expiry Date"),
      sort: false,
      formatter: (cell, row) => {
        return row.expiry_date
          ? moment(row.expiry_date).format("DD/MM/YYYY HH:mm")
          : "";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "11%" };
      },
    },
    {
      dataField: "unit_for_po",
      text: props.t("Cost Price"),
      formatter: (cell, row) => {
        return row.cost_price + "/" + row.unit_for_po;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "total_price",
      text: props.t("Total"),
      formatter: (cell, row) => {
        return row?.total_price?.toFixed(2) || 0;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
  ];
  const handleReceiveTransfer = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemreturns/receive";
    const response = await postSubmitForm(url, {
      return_id: selectedTransfer.return_id,
    });
    if (response && response.status === 1) {
      loadAllReturns();
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };

  const handleDownload = async () => {
    const fileName = "central_return_orders";
    const exportType = "xls";

    let data_to_export = allReturns;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          ReturnID: v.return_id,
          Return_from: v.branch_details.name,
          Return_To:
            v.return_to.supplier === null
              ? v.return_to.central_store.name
              : v.return_to.supplier.name,
          Remarks: v.remarks,
          Date: v.createdAt,
          Status: v.status,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("All Returns ")}
            title={props.t("All Returns")}
            breadcrumbItem1={props.t("Return")}
          />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(selectedDate);

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(selectedDate);
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadAllReturns();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    {/* <CardTitle className="text-center">
                      {props.t("Item Transfer Inventory")}
                    </CardTitle> */}

                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allReturnsFiltered && allReturnsFiltered}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                      exportCSV
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={5}></Col>
                            <Col lg={3} className="text-right">
                              <select
                                name="status"
                                className="form-control"
                                value={selectedStatus}
                                onChange={(e) => {
                                  setSelectedStatus(e.target.value);
                                }}
                              >
                                <option value="All">All</option>
                                <option value="Placed">Placed</option>
                                <option value="Closed">Closed</option>
                              </select>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                  <Modal
                    size="lg"
                    style={{
                      width: "980px",
                      maxWidth: "990px",
                    }}
                    isOpen={detailsModal}
                    toggle={() => setDetailsModal(!detailsModal)}
                  >
                    <ModalHeader toggle={() => setDetailsModal(!detailsModal)}>
                      Return Item Details
                    </ModalHeader>
                    <ModalBody>
                      {selectedTransfer_Items && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={
                                          selectedTransfer_Items &&
                                          selectedTransfer_Items
                                        }
                                        columns={columns_items}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>

                  {confirmReceive && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmReceive(false);
                        handleReceiveTransfer();
                      }}
                      onCancel={() => {
                        setConfirmReceive(false);
                      }}
                    >
                      {props.t(
                        "Once you receive this return, it cannot be revoked.",
                      )}
                    </SweetAlert>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(CentralStoreAllItemReturn)),
);
